// Changing a deal's lot moves the same deal, with its options and deposits, to the new lot.
// Mirrors backend Shared/DataTransferObjects/DealLotChangeDto.cs.

export const DEAL_LOT_CHANGE_DESIGN_RULES = 'DEAL_LOT_CHANGE_DESIGN_RULES';
export const DEAL_LOT_CHANGE_ADMIN_ONLY = 'DEAL_LOT_CHANGE_ADMIN_ONLY';

export type LotChangeOptionsAction = 'MoveWithBuyer' | 'KeepOnOldLot';

/** Same body for the preview and the real change. */
export interface DealLotChangeRequest {
  newLotId: string;
  optionsAction: LotChangeOptionsAction;
  modelId?: string;
  elevationId?: string;
  /** Omit to keep the current premium. Never send 0 as a placeholder. */
  unitPremiumPrice?: number;
  keepModelOnOldLot: boolean;
  /** False on the first attempt, true only after the user accepted the violated rules. */
  designRuleConfirmed: boolean;
  /** The preview's fingerprint. Omitted on preview; required on confirm, which returns 409 when it no longer matches. */
  fingerprint?: string;
}

export interface LotChangeAddendum {
  addendumId: string;
  seq: number;
  total: number;
  isLocked: boolean;
}

export interface LotChangeDroppedAddendum {
  addendumId: string;
  seq: number;
  total: number;
}

export interface LotChangeDroppedProduct {
  addendumId: string;
  addendumSeq: number;
  addendumProductId: string;
  productCode: string | null;
  productDescription: string | null;
  unitPrice: number;
  linkedChildCount: number;
}

export interface DealLotChangeResult {
  isPreview: boolean;
  dealId: string;
  oldLotId: string;
  newLotId: string;
  oldLotNo: string;
  newLotNo: string;
  optionsAction: LotChangeOptionsAction;
  newLotStatus: string;
  movedAddendums: LotChangeAddendum[];
  keptOnOldLotAddendums: LotChangeAddendum[];
  /** Keep on the old lot: the options that were not approved and are switched off. */
  switchedOffAddendums: LotChangeAddendum[];
  droppedAddendums: LotChangeDroppedAddendum[];
  droppedProducts: LotChangeDroppedProduct[];
  depositsMoved: number;
  depositsMovedTotal: number;
  depositsUnlinked: number;
  roomRulesToRerun: number;
  documentsNamingOldLot: string[];
  notesMoved: number;
  modelKeptOnOldLot: boolean;
  modelKeepForcedByRule: boolean;
  unitPremiumPriceBefore: number;
  unitPremiumPriceAfter: number;
  confirmedDesignRules: string[];
  warnings: string[];
  /** Hash of what this result covers; send it back on confirm. */
  fingerprint: string;
}

export interface DealLotChangeDesignRuleViolation {
  newLotId: string;
  newLotNo: string | null;
  modelId: string | null;
  elevationId: string | null;
  violatedRules: string[];
}
